export const GET_PROMOS = "GET_PROMOS";
export const SET_PROMOS = "SET_PROMOS";
